import { sortBy } from 'lodash';
import map from 'lodash/map';

export const sort = (unsorted?: any) => {
  if (!unsorted) {
    return undefined;
  }
  return sortBy(unsorted, s => {
    return new Date(s.date || s.dateId).getTime();
  });
};

export const colors = [
  'rgba(255, 99, 132, 1.2)',
  'rgba(54, 162, 235, 1.2)',
  'rgba(255, 206, 86, 1.2)',
  'rgba(75, 192, 192, 1.2)',
  'rgba(153, 102, 255, 1.2)',
  'rgba(255, 159, 64, 1.2)',
  'rgba(55, 159, 64, 1.2)',
  'rgba(255, 59, 64, 1.2)',
  'rgba(55, 159, 164, 1)',
  'rgba(55, 19, 164, 1.2)',
  'rgba(255, 59, 164, 1.2)',
  'rgba(55, 59, 164, 1)',
];

export const getObjectsDataSet = (data, deviceId) => {
  const byObject = {};

  // Sort dates by order field before processing
  const sortedDates = sortBy(Object.entries(data), ([dateKey, dateData]) => {
    return dateData.order !== undefined ? dateData.order : 999999;
  });

  map(sortedDates, ([date, dateData]) => {
    return map(dateData.objects, (object, objectId) => {
      if (!byObject[object.deviceTypeObjectId]) {
        byObject[object.deviceTypeObjectId] = {
          dates: {},
          label: object.deviceTypeObject?.name,
          isDangerous: object.isDangerous,
        };
      }
      if (!byObject[object.deviceTypeObjectId].dates[date]) {
        byObject[object.deviceTypeObjectId].dates[date] = {};
      }
      byObject[object.deviceTypeObjectId].dates[date] = { 
        ...object, 
        dateId: object.dateId || dateData.dateId || dateData.date,
        order: dateData.order
      };
    });
  });

  let index = 0;
  return map(byObject, (value, objectTypeId) => {
    // Sort dates by order field
    const sortedDates = sortBy(Object.entries(value.dates), ([dateKey, dateData]) => {
      return dateData.order !== undefined ? dateData.order : 999999;
    });
    
    const result = {
      label: `${value.label} (${value.isDangerous ? 'NB' : 'B'})`,
      fill: false,
      backgroundColor: colors[index],
      borderColor: colors[index],
      data: sortedDates.map(([date, object]) => {
        return { y: object.amount, x: object.dateId, order: object.order };
      }),
    };
    index++;
    return result;
  });
};

export const getActionsDataSet = (data, deviceId) => {
  let index = 0;
  const byAction = {};

  // Sort dates by order field before processing
  const sortedDates = sortBy(Object.entries(data), ([dateKey, dateData]) => {
    return dateData.order !== undefined ? dateData.order : 999999;
  });

  map(sortedDates, ([date, dateData]) => {
    return map(dateData.actions, (action, actionId) => {
      if (!byAction[action.deviceTypeActionId]) {
        byAction[action.deviceTypeActionId] = {
          dates: {},
          label: action.deviceTypeAction?.name,
        };
      }
      if (!byAction[action.deviceTypeActionId].dates[date]) {
        byAction[action.deviceTypeActionId].dates[date] = {};
      }
      byAction[action.deviceTypeActionId].dates[date] = { 
        ...action, 
        dateId: dateData.dateId || dateData.date,
        order: dateData.order
      };
    });
  });

  return map(byAction, (value, actionTypeId) => {
    // Sort dates by order field
    const sortedDates = sortBy(Object.entries(value.dates), ([dateKey, dateData]) => {
      return dateData.order !== undefined ? dateData.order : 999999;
    });
    
    const result = {
      label: value.label,
      fill: false,
      backgroundColor: colors[index],
      borderColor: colors[index],
      data: sortedDates.map(([date, action]) => {
        return { y: action.amount, x: action.dateId, order: action.order };
      }),
    };
    index++;
    return result;
  });
};

export const getObservationsDataSet = (data, deviceId) => {
  let index = 0;
  const byObservation = {};

  // Sort dates by order field before processing
  const sortedDates = sortBy(Object.entries(data), ([dateKey, dateData]) => {
    return dateData.order !== undefined ? dateData.order : 999999;
  });

  map(sortedDates, ([date, dateData]) => {
    return map(dateData.observations, (observation, observationId) => {
      if (!byObservation[observation.deviceTypeObservationId]) {
        byObservation[observation.deviceTypeObservationId] = {
          dates: {},
          label: observation.deviceTypeObservation?.name,
        };
      }
      if (!byObservation[observation.deviceTypeObservationId].dates[date]) {
        byObservation[observation.deviceTypeObservationId].dates[date] = {};
      }
      byObservation[observation.deviceTypeObservationId].dates[date] = { 
        ...observation, 
        dateId: dateData.dateId || dateData.date,
        order: dateData.order
      };
    });
  });

  return map(byObservation, (value, observationTypeId) => {
    // Sort dates by order field
    const sortedDates = sortBy(Object.entries(value.dates), ([dateKey, dateData]) => {
      return dateData.order !== undefined ? dateData.order : 999999;
    });
    
    const result = {
      label: value.label,
      fill: false,
      backgroundColor: colors[index],
      borderColor: colors[index],
      data: sortedDates.map(([date, observation]) => {
        return { y: observation.amount, x: observation.dateId, order: observation.order };
      }),
    };
    index++;
    return result;
  });
};

